// src/util/getChildrenWithIconProps/constants.ts
var ICON_DEFAULT_PROPS = {
  // reset sizes
  large: void 0,
  medium: void 0,
  small: void 0,
  width: void 0,
  height: void 0,
  fontSize: void 0,
  // reset color
  color: void 0,
  // reset margin
  margin: void 0,
  marginX: void 0,
  marginY: void 0,
  marginTop: void 0,
  marginBottom: void 0,
  marginLeft: void 0,
  marginRight: void 0
};
var ICON_COMPONENT_SUFFIX = "Icon";
export { ICON_DEFAULT_PROPS, ICON_COMPONENT_SUFFIX };